import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';
import { AGGREGATION_TYPE, AGGREGATION_TYPE_LABELS } from 'components/View/constants';

import CMASummaryTableDataValuesDifference from './CMASummaryTableDataValuesDifference';
import { CMASummaryFilters } from './types';
import { parseCMASummaryFeeData } from './utils';

const Title = styled.span`
  font-family: var(--font-regular);
  font-size: 14px;
  display: inline-block;
  max-width: 220px;
  white-space: normal;
  overflow-wrap: break-word;
`;

const Subtitle = styled.div`
  color: var(--text-secondary);
  font-size: 12px;
  max-width: 220px;
  white-space: normal;
  overflow-wrap: break-word;
`;

const AggregationType = styled.span`
  margin-left: 4px;
  text-transform: lowercase;
`;

type Props = {
  fees: any[];
  aggregationType?: number;
  dataTestId?: string;
};

const CMASummaryTableDataFeesGroup = ({ fees, aggregationType, dataTestId }: Props) => {
  const { viewFilters } = useCommunityViewContext();
  const filters = viewFilters as CMASummaryFilters;

  const [value, type, subtitle, note] = fees;
  const [feeLevelValue, feeLevelDifference] = parseCMASummaryFeeData(value, filters?.viewOptions?.valueDisplay);
  const resolvedAggregationType = aggregationType ?? filters?.careLevelsStatsType ?? AGGREGATION_TYPE.AVG;
  const hasFeeLevelValue = feeLevelValue !== null && feeLevelValue !== undefined;

  return (
    <div data-test-id={dataTestId}>
      {hasFeeLevelValue && (
        <Title>
          ${feeLevelValue.toLocaleString(undefined, { maximumFractionDigits: 0 })}
          <AggregationType>{AGGREGATION_TYPE_LABELS[resolvedAggregationType]}</AggregationType>
          <CMASummaryTableDataValuesDifference difference={feeLevelDifference} />
        </Title>
      )}
      {!hasFeeLevelValue && <Title>{type}</Title>}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      {note && <Subtitle>{note}</Subtitle>}
    </div>
  );
};

export default CMASummaryTableDataFeesGroup;
